import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TableWrapper = styled.div({
	borderWidth: '1px',
	borderStyle: 'solid',

	borderColor: token('color.border'),

	backgroundColor: token('elevation.surface.raised'),
	borderRadius: token('space.050'),
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Table = styled.table({
	width: '100%',
	borderCollapse: 'collapse',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TableHeadRowContainer = styled.tr({
	maxHeight: token('space.500'),
	height: token('space.500'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CheckboxLabelContainer = styled.span({
	color: token('color.text.subtle'),
	paddingTop: token('space.150'),
	paddingBottom: token('space.150'),
	fontWeight: token('font.weight.medium'),
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeadCellContainer = styled.th({
	display: 'table-cell',
	appearance: 'none',
	verticalAlign: 'middle',
	fontWeight: token('font.weight.medium'),

	color: token('color.text.subtle'),
	width: '100%',
	paddingRight: token('space.050'),
	paddingLeft: token('space.050'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:first-of-type': {
		paddingLeft: token('space.200'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TableHeadContainer = styled.thead({
	verticalAlign: 'middle',
	inset: 0,
	position: 'relative',
	borderBottomStyle: 'none',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:before': {
		position: 'absolute',

		boxShadow: `inset 0 -1px 0 0 ${token('color.border')}`,
		content: '',
		inset: 0,
		pointerEvents: 'none',
		bottom: 0,
		top: 0,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TBody = styled.tbody({
	border: 'none',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CellContainer = styled.td({
	borderCollapse: 'separate',
	appearance: 'none',
	boxSizing: 'border-box',
	display: 'table-cell',
	paddingRight: token('space.050'),
	paddingLeft: token('space.050'),
	verticalAlign: 'middle',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:first-of-type': {
		paddingLeft: token('space.200'),
	},
});
